import _extends from "@babel/runtime/helpers/extends";
import { colorUseCases, getColorScaleFromThemeObject, theme } from "@vitality-ds/system";
var text = colorUseCases.text;
export default (function (baseStyles) {
  return _extends({}, baseStyles, {
    color: getColorScaleFromThemeObject("neutralA", text.lowContrast, theme),
    gap: theme.space.xs.value
  });
});